import { Helmet } from "react-helmet";
import { useState } from "react";
import TradeHistoryTable from "./Cosmetic/detail/TradeHistoryTable";
import Collection from "./Profile/Collection";
import NameSearch from "./Profile/NameSearch";

export default function Profile() {
  const [tradeHistory, setTradeHistory] = useState();
  const [playerItem, setPlayerItem] = useState();
  const playerName = playerItem?.name || "Search";

  const avatarUrl = playerItem
    ? `https://api.zeqa.net/api/players/avatars/${encodeURIComponent(
        playerName
      )}`
    : "https://api.zeqa.net/api/players/avatars/steve";

  const description = playerItem
    ? `View ${playerName}'s trade history and cosmetic collection.`
    : "Search for a player to see their profile.";

  return (
    <div>
      <Helmet>
        <title>
          {playerItem ? `${playerName}'s Profile` : "Profile Search"}
        </title>
        <meta name="description" content={description} />
        <meta property="og:title" content={playerName} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={avatarUrl} />
        <meta property="twitter:title" content={playerName} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={avatarUrl} />
      </Helmet>
      <div className="page_container">
        <br />
        <br />
        <div className="w-layout-grid grid-title">
          <div className="zeqa--subtitle">profile</div>
          <h1 className="large-heading">search</h1> <br />
        </div>
        <NameSearch
          setPlayerItem={setPlayerItem}
          setTradeHistory={setTradeHistory}
        />{" "}
        <br />
        {tradeHistory && (
          <div className="home_container">
            <h1 style={{ color: "#ffc800", marginBottom: 30, fontSize: 18 }}>
              Trade History
            </h1>
            <TradeHistoryTable tradeLog={tradeHistory} />
          </div>
        )}{" "}
        <br />
        {playerItem && (
          <div className="home_container">
            <h1 style={{ color: "#ffc800", marginBottom: 30, fontSize: 18 }}>
              Cosmetic Collection
            </h1>
            <Collection playerItem={playerItem} />
          </div>
        )}
      </div>
    </div>
  );
}
